<template>
  <header id="site-nav" class="site-nav">
    <div class="site-nav__wrapper">
      <div class="site-nav__wrapper__left">
        <div class="logo">
          <router-link to="/"></router-link>
        </div>
        <div class="welcome" v-if="currentUserProfile">
          Welcome,
          <router-link to="/update-profile">
            {{ userProfile.firstName }}
          </router-link>
        </div>
      </div>
      <Menu/>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Menu from '@/components/Menu'

export default {
  name: 'SiteHeader',
  components: {
    Menu
  },
  computed: {
    ...mapState([
      'isAdmin',
      'userProfile'
    ]),
    ...mapGetters([
      'currentUserProfile'
    ])
  }
}
</script>
<style lang="scss" scoped>
header {
  background: $primary;
}
.site-nav {
  &__wrapper {
    flex-grow: 1;
    flex-basis: 50%;
    padding: 1rem 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
    a {
      color: white;
    }
    &__left {
      display:flex;
      align-items:center;
      .logo a {
        @include logo;
      }
      h3 {
        margin-bottom: 0;
      }
      .welcome {
        padding-left: 2rem;
        @media ($sm-down) {
          display: none;
        }
      }
    }

  }
}
</style>